export const trellisColors = {
  lime: '#ebff6e',
  teal: '#00414b',
} as const
